// extracted by mini-css-extract-plugin
export var errorIcon = "_pm-1";
export var nameLogo = "_pm-0";